import { formatAmount } from './formatters';

const normalizeSearchText = (value) => String(value ?? '').toLowerCase().trim();

const appendSearchPart = (parts, value) => {
  if (value === null || value === undefined || value === '') {
    return;
  }
  parts.push(String(value));
};

const getRowSearchText = (row, columns) => {
  const parts = [];

  columns.forEach((column) => {
    if (column.key === 'index') {
      return;
    }

    const value = row[column.key];
    appendSearchPart(parts, value);

    if (column.type === 'status') {
      appendSearchPart(parts, row[column.labelKey || 'statusLabel']);
      appendSearchPart(parts, row[column.statusKey || 'status']);
    }

    if (column.type === 'amount') {
      appendSearchPart(parts, formatAmount(value));
      appendSearchPart(parts, formatAmount(value, { withSymbol: false }));
    }
  });

  return normalizeSearchText(parts.join(' '));
};

export const filterTableRows = (rows, columns, searchTerm) => {
  const query = normalizeSearchText(searchTerm);
  if (!query || !rows.length) {
    return rows;
  }

  return rows.filter((row) => getRowSearchText(row, columns).includes(query));
};
